/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SaveAsanaCredentialsInput = {
    clientMutationId?: string | null | undefined;
    code: string;
    orgRelayId: string;
    redirectUri: string;
};
export type SaveAsanaCredentialsMutationVariables = {
    input: SaveAsanaCredentialsInput;
};
export type SaveAsanaCredentialsMutationResponse = {
    readonly saveAsanaCredentials: {
        readonly clientMutationId: string | null;
    } | null;
};
export type SaveAsanaCredentialsMutation = {
    readonly response: SaveAsanaCredentialsMutationResponse;
    readonly variables: SaveAsanaCredentialsMutationVariables;
};



/*
mutation SaveAsanaCredentialsMutation(
  $input: SaveAsanaCredentialsInput!
) {
  saveAsanaCredentials(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "SaveAsanaCredentialsPayload",
            "kind": "LinkedField",
            "name": "saveAsanaCredentials",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SaveAsanaCredentialsMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SaveAsanaCredentialsMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "31d8259201dcf873f2d7a1a317b66f3e",
            "id": null,
            "metadata": {},
            "name": "SaveAsanaCredentialsMutation",
            "operationKind": "mutation",
            "text": "mutation SaveAsanaCredentialsMutation(\n  $input: SaveAsanaCredentialsInput!\n) {\n  saveAsanaCredentials(input: $input) {\n    clientMutationId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'bb1af3223710396d4d57dddad976a632';
export default node;
